import { action } from 'satcheljs';
import { OwaDate } from 'owa-datetime';
import { AgendaScenarioViewConfig } from '../store/agendaStore';
import { IPoint } from '@fluentui/react/lib/Utilities';
import { ActionSource } from 'owa-todo-types';

export const rightClickAgendaTodo = action(
    'rightClickAgendaTodo',
    (todoId: string, anchor: IPoint, scenarioId: string) => ({
        todoId,
        anchor,
        scenarioId,
    })
);

export const clickAgendaTodo = action('clickAgendaTodo', (todoId: string, scenarioId: string) => ({
    todoId,
    scenarioId,
}));

export const updateShouldShowTasks = action(
    'updateShouldShowTasks',
    (shouldShowTasks: boolean, scenarioId: string) => ({
        shouldShowTasks,
        scenarioId,
    })
);

export const updateSelectedCalendarEvent = action(
    'updateSelectedCalendarEvent',
    (selectedCalendarEventId: string, scenarioId: string) => ({
        selectedCalendarEventId,
        scenarioId,
    })
);

export const updateIncludeDeclinedEvents = action(
    'updateIncludeDeclinedEvents',
    (scenarioId: string, shouldShowDeclinedEvents: boolean) => ({
        scenarioId,
        shouldShowDeclinedEvents,
    })
);

export const initializeAgenda = action(
    'initializeAgenda',
    (
        date: OwaDate,
        calendarIds: string[],
        scenarioId: string,
        shouldShowTasks: boolean,
        shouldShowDeclinedEvents: boolean,
        todoActionSource: ActionSource,
        viewConfig: AgendaScenarioViewConfig
    ) => ({
        date,
        calendarIds,
        viewConfig,
        shouldShowTasks,
        todoActionSource,
        shouldShowDeclinedEvents,
        scenarioId,
    })
);

export const updateSearchText = action(
    'updateSearchText',
    (scenarioId: string, searchText: string) => ({
        scenarioId,
        searchText,
    })
);

export const updateSelectedDate = action(
    'updateSelectedDate',
    (date: OwaDate, scenarioId: string) => ({
        date,
        scenarioId,
    })
);

export const updateCalendarIds = action(
    'updateCalendarIds',
    (calendarIds: string[], scenarioId: string) => ({
        calendarIds,
        scenarioId,
    })
);
